import React from 'react';
import { Hexagon } from 'lucide-react';

const Logo = ({
  variant = 'full',
  theme = 'dark',
  className = '',
  iconClassName = 'h-9 w-auto',
  wordClassName = 'text-xl',
}) => {
  if (variant === 'icon') {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <Hexagon className={`${iconClassName} ${theme === 'dark' ? 'text-[#00D4CB]' : 'text-[#2563EB]'}`} fill="currentColor" fillOpacity={0.15} />
      </div>
    );
  }

  const textColor = theme === 'dark' ? 'text-white' : 'text-slate-900';

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <Hexagon className={`${iconClassName} text-[#00D4CB]`} fill="currentColor" fillOpacity={0.15} />
      <div className="leading-none">
        <span className={`font-extrabold tracking-tight ${wordClassName} ${textColor}`}>
          Connect<span className="brand-text-gradient">Ops</span>
        </span>
      </div>
    </div>
  );
};

export default Logo;
